import IconCardSelector from "@/components/form/icon-card-selector";
import ImageWithLoading from "@/components/image/image-with-loading";
import { IonSkeletonText } from "@ionic/react";

const brandLogosMap: Record<string, string> = {
  Asda: "/assets/icons/supermarket/asda.webp",
  "M&S": "/assets/icons/supermarket/ms.webp",
  "Sainsbury's": "/assets/icons/supermarket/sainsburys.webp",
  Tesco: "/assets/icons/supermarket/tesco.webp",
  Lidl: "/assets/icons/supermarket/lidl.webp",
  Aldi: "/assets/icons/supermarket/aldi.webp",
  Morrisons: "/assets/icons/supermarket/morrisons.webp",
  Waitrose: "/assets/icons/supermarket/waitrose.webp",
} as const;

interface SupermarketSelectionListProps {
  isLoading: boolean;
  options: string[];
  selectedPreference: Set<string>;
  handlePreferenceSelect: (preference: string) => () => void;
}

export default function SupermarketSelectionList({
  isLoading,
  options,
  selectedPreference,
  handlePreferenceSelect,
}: SupermarketSelectionListProps) {
  if (isLoading) {
    return (
      <div className="w-full flex flex-col gap-4">
        <IonSkeletonText animated className="h-20 rounded-xl" />
        <IonSkeletonText animated className="h-20 rounded-xl" />
        <IonSkeletonText animated className="h-20 rounded-xl" />
        <IonSkeletonText animated className="h-20 rounded-xl" />
      </div>
    );
  }
  return (
    <div className="pb-20 h-full w-full overflow-y-auto no-scrollbar flex flex-col gap-4">
      {options?.map((option) => {
        const src = brandLogosMap[option];
        return (
          <IconCardSelector
            key={option}
            icon={
              <ImageWithLoading
                src={src}
                alt={option}
                classNames={{
                  container: "w-6 h-6",
                  image: "w-6 h-6",
                }}
              />
            }
            title={option}
            description={option}
            selected={selectedPreference?.has(option)}
            onClick={handlePreferenceSelect(option)}
          />
        );
      })}
    </div>
  );
}
